const replaceComma = (str) => {
  return String(str).replace(/,/g, "");
};

export default replaceComma;
